import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './store/auth';
import { SiteProvider, useSite } from './store/site';
import Login from './pages/Login';
import Rapport from './pages/Rapport';
import Dashboard from './pages/Dashboard';
import SiteSelect from './pages/SiteSelect';
import ChangePassword from './pages/ChangePassword';
import Admin from './pages/Admin';

const OFFICE = ['BUREAU','ADMIN','CLIENT'];

function Guard({ children, roles, needSite }) {
  const { user } = useAuth();
  const { site } = useSite();
  if (!user) return <Navigate to="/login" replace/>;
  if (user.mustChangePassword) return <Navigate to="/change-password" replace/>;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace/>;
  // Le terrain choisit son chantier ; bureau/admin/client atterrissent direct
  // sur le dashboard qui auto-sélectionne.
  if (needSite && !site && !OFFICE.includes(user.role)) return <Navigate to="/select-site" replace/>;
  return children;
}

function Home() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace/>;
  if (user.mustChangePassword) return <Navigate to="/change-password" replace/>;
  return <Navigate to={OFFICE.includes(user.role) ? '/dashboard' : '/rapport'} replace/>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Home/> : <Login/>}/>
      <Route path="/change-password" element={user ? <ChangePassword/> : <Navigate to="/login" replace/>}/>
      <Route path="/select-site" element={user ? <SiteSelect/> : <Navigate to="/login" replace/>}/>
      <Route path="/rapport" element={<Guard roles={['TECH','CHEF','BUREAU','ADMIN']} needSite><Rapport/></Guard>}/>
      <Route path="/dashboard" element={<Guard roles={OFFICE} needSite><Dashboard/></Guard>}/>
      <Route path="/admin" element={<Guard roles={['ADMIN']}><Admin/></Guard>}/>
      <Route path="*" element={<Home/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <BrowserRouter>
          <AppRoutes/>
        </BrowserRouter>
      </SiteProvider>
    </AuthProvider>
  );
}
